export default [
  {
    name: 'Auth.Login',
    path: 'login',
    component: () => import('./components/Login')
  },
  {
    name: 'Auth.Register',
    path: 'register',
    component: () => import('./components/Register')
  },
  {
    name: 'Auth.Reset',
    path: 'reset',
    component: () => import('./components/Reset')
  },
  {
    name: 'Auth.ResetConfirmEmail',
    path: 'reset-confirm-email/:id',
    props: true,
    component: () => import('./components/ResetConfirmEmail')
  },
  {
    name: 'Auth.ResetConfirmPhone',
    path: 'reset-confirm-phone/:id',
    props: true,
    component: () => import('./components/ResetConfirmPhone')
  },
  {
    name: 'Auth.ResetNotify',
    path: 'reset-notify',
    component: () => import('./components/ResetNotify')
  },
  {
    name: 'Auth.Notify',
    path: 'notify',
    component: () => import('./components/Notify')
  },
  {
    name: 'Auth.ConfirmEmail',
    path: 'confirm-email/:id',
    props: true,
    component: () => import('./components/ConfirmEmail')
  },
  {
    name: 'Auth.ConfirmPhone',
    path: 'confirm-phone/:id',
    props: true,
    component: () => import('./components/ConfirmPhone')
  }
]
